import { render, staticRenderFns } from "./AlertBar.vue?vue&type=template&id=4937a8f9&scoped=true&"
import script from "./AlertBar.vue?vue&type=script&lang=ts&"
export * from "./AlertBar.vue?vue&type=script&lang=ts&"
import style0 from "./AlertBar.vue?vue&type=style&index=0&id=4937a8f9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4937a8f9",
  null
  
)

export default component.exports